import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import useWindowSize from './Globals/Helpers/useWindowSize';

import Home from "./Pages/Home/Home";
import SignUp from "./Pages/SignUp/SignUp";
import Login from "./Pages/Login/Login";
import Buy from "./Pages/Buy/Buy";
import Listings from "./Pages/Listings/Listings";
import ListingDetail from "./Pages/ListingDetail/ListingDetail";
import UserListings from "./Pages/UserListings/UserListings";
import Profile from "./Pages/Profile/Profile";
import Chats from "./Pages/Chats/Chats";
import Navbar from "./Pages/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import CreateAccount from './Pages/CreateAccount/CreateAccount';
import ForgotPassword from './Pages/ForgotPassword/ForgotPassword';
import HowItWorks from './Pages/HowItWorks/HowItWorks';
import Contact from './Pages/Contact/Contact';
import Dashboard from './Pages/Dashboard/Dashboard';

const theme = createTheme({
  typography: {
    fontFamily: ['Ubuntu', 'sans-serif'].join(','),
  }
});

function AppContent({ courseCode, setCourseCode }) {
  const location = useLocation();
  const { width } = useWindowSize();
  const isMobile = width <= 768;
  
  // Define footer spacing for different pages
  const getFooterMargin = () => {
    switch (location.pathname) {
      case '/':
        return isMobile ? '300px' : '90px'; // Home page - much more spacing on mobile
      case '/login':
        return isMobile ?'200px' : '100px'; // Login page - adjust this value
      case '/create-account':
        return '80px'; // Sign up page - increased spacing
      case '/dashboard':
        return '50px'; // Dashboard page - minimal spacing needed
      case '/listings':
        return '75px'; // Listings page - adjust this value
      case '/my-listings':
        return '90px'; // My listings page - adjust this value
      case '/buy':
        return '100px'; // Buy page - adjust this value
      case '/how-it-works':
        return '50px'; // How it works page - adjust this value
      case '/contact':
        return '50px'; // Contact page - adjust this value
      case '/forgot-password':
        return isMobile ? '330px' : '120px'; // Forgot password page - much more space needed
      default:
        return '200px'; // Default spacing
    }
  };

  return (
    <>
      <Navbar courseCode={courseCode} setCourseCode={setCourseCode} />
      <Routes>
        <Route path="/" Component={Home} />
        <Route path="/profile" Component={Profile} />
        <Route path="/my-listings" Component={UserListings} />
        <Route path="/chats" Component={Chats} />
        <Route path="/login" Component={Login} />
        <Route path="/sign-up" Component={SignUp} />
        <Route path="/listings" element={<Listings courseCode={courseCode} setCourseCode={setCourseCode} />} />
        <Route path="/listing/:id" Component={ListingDetail} />
        <Route path="/buy" Component={Buy} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/how-it-works" Component={HowItWorks} />
        <Route path="/contact" Component={Contact} />
        <Route path="/dashboard" Component={Dashboard} />
      </Routes>
      <Footer marginTop={getFooterMargin()} />
    </>
  );
}

export default function App() {
  const [courseCode, setCourseCode] = useState('all');

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AppContent courseCode={courseCode} setCourseCode={setCourseCode} />
      </Router>
    </ThemeProvider>
  );
}
